import { COUNTRY_CODES } from '@/constants/country-codes';

export function isMobile(value: string, countryCode: string) {
    return countryCode === COUNTRY_CODES.Greek
        ? /^69\d{8}$/.test(value)
        : /^\d{7,15}$/.test(value);
}
